export enum Notification_Type {
  documents = 1,
  payslips,
  form106,
  paymentAndDeductionsDetails,
  medicalReferrals,
  medicationOrders,
  prescriptions,
  requests,
  equipments,
  recognitionProcess,
}
